import * as Butter from 'buttercms';

export const butterService = Butter('e16a42b5945d0626d0699f64b35b3cd2784df62b');



// WEBPACK FOOTER //
// ./src/app/components/blog/_services/butterCMS.service.ts